import React, { FC } from "react";
import { AutoComplete, Form, Input } from "antd";
import Util from "../../../util/util";
import { IPaymentPageCustomAttribute } from "@app-models";
import { VALIDATION_SUB_TYPE } from "../constants";
import { FormFieldBox } from "./FormFieldBox";

interface ValidatedTextFieldInputProps {
  name: string;
  attribute: IPaymentPageCustomAttribute;
}

const ValidatedTextFieldInput: FC<ValidatedTextFieldInputProps> = ({ name, attribute }) => {
  const isSupportedSubType =
    !attribute.validationSubType ||
    attribute.validationSubType === "null" ||
    attribute.validationSubType === VALIDATION_SUB_TYPE.VALIDATED_TEXT_FIELD_LIST ||
    attribute.validationSubType === VALIDATION_SUB_TYPE.VALIDATED_TEXT_FIELD_DATASOURCE;

  if (!isSupportedSubType) {
    return null;
  }

  let allowedValues: string[] = [];
  try {
    if (attribute.validationValue) {
      const parsed = JSON.parse(attribute.validationValue as string);
      allowedValues = Array.isArray(parsed) ? (parsed as string[]) : [];
    }
  } catch (e) {
    allowedValues = [];
  }

  const placeholderText = allowedValues.length === 1 ? allowedValues[0] : attribute.fieldName;

  return (
    <div className="name-field field-title-case">
      <Form.Item
        name={name}
        rules={[
          { required: attribute.mandatory, message: "Field is mandatory" },
          {
            validator: (rule, value, callback) =>
              Util.validateTextFieldWithCustomValues(rule, value, callback, allowedValues),
          },
        ]}
        key={name}
      >
        <FormFieldBox label={attribute.fieldName}>
          {(props) => (
            <AutoComplete
              {...props}
              options={allowedValues.map((v) => ({ value: v }))}
              filterOption={(inputValue, option) =>
                (option?.value as string)?.toUpperCase().includes(inputValue.toUpperCase())
              }
            >
              <Input type="text" className="form-input-style" placeholder={placeholderText} />
            </AutoComplete>
          )}
        </FormFieldBox>
      </Form.Item>
    </div>
  );
};

export default ValidatedTextFieldInput;
